export default "__VITE_ASSET__C382WFSX__"